export default "__VITE_ASSET__BZdMKCj1__"